<template>
    <div id="sc-message-list" ref="scrollList" :style="{ backgroundColor: 'transparent' }" class="sc-message-list">
        <Message
            v-for="(message, idx) in messages"
            :key="message.raw.uniqMessageId"
            :id="'sc-message_' + message.raw.uniqMessageId"
            :colors="colors"
            :message="message"
            :lastMessage="$_.last(messages.filter((x) => x.author === 'chatbot'))"
            :messageStyling="messageStyling"
            :participants="participants"
            :user="profile(message.author)"
            @remove="$emit('remove', message)"
            :conversation-terminated="conversationTerminated"
            v-if="isVisibleMessage(message)"
        >
            <template v-slot:user-avatar="scopedProps">
                <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
            </template>
            <template v-slot:text-message-body="scopedProps">
                <slot
                    :me="scopedProps.me"
                    :message="scopedProps.message"
                    :messageColors="scopedProps.messageColors"
                    :messageText="scopedProps.messageText"
                    name="text-message-body"
                >
                </slot>
            </template>
            <template v-slot:text-message-toolbox="scopedProps">
                <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox"></slot>
            </template>
        </Message>

        <Message
            v-show="showTypingIndicator !== ''"
            :colors="colors"
            :message="{ author: showTypingIndicator, type: 'typing' }"
            :messageStyling="messageStyling"
            :user="{}"
        />
        <slot name="rate" />
    </div>
</template>

<script>
import Message from "./Message.vue";
import chatIcon from "./assets/chat-icon.svg";
import { log2 } from "../../../utils/log2";
import EllipsIconButton from "../../../common/IconButton.vue";
import _ from "lodash";

const log = log2("MessageList");
export default {
    components: {
        Message,
        EllipsIconButton,
    },
    props: {
        onSubmit: {
            type: Function,
            required: false,
            default: () => {},
        },
        participants: {
            type: Array,
            default: () => [],
        },
        messages: {
            type: Array,
            required: true,
        },
        showTypingIndicator: {
            type: String,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },
        messageStyling: {
            type: Boolean,
            required: true,
        },
        scrollVS: {
            required: false,
        },
        conversationTerminated: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            existNewMessage: false,
        };
    },
    methods: {
        _scrollDown() {
            // log("_scrollDown", this.scrollVS);
            //this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
            if (this.scrollVS) {
                this.scrollVS.scrollTo({
                    x: 0,
                    y: "100%",
                });
            }
        },
        shouldScrollToBottom() {
            // log(
            //     "shouldScrollToBottom",
            //     this.alwaysScrollToBottom || this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - 600
            // );
            return (
                this.alwaysScrollToBottom || this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - 600
            );
        },
        profile(author) {
            const profile = this.participants.find((profile) => profile.id === author);

            // A profile may not be found for system messages or messages by 'me'
            return profile || { imageUrl: "", name: author === "chatbot" ? "Müşteri Temsilcisi" : "" };
        },
        isVisibleMessage(message) {
            console.log("isVisibleMessage", message);
            return _.get(message, "raw.systemMessageType") !== "custom";
        },
    },
    computed: {
        defaultChatIcon() {
            return chatIcon;
        },
    },
    mounted() {
        log("mounted");
        this.$emit("mounted");
        this.$nextTick(this._scrollDown());
    },
    updated() {
        if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
    },
};
</script>

<style scoped lang="scss">
.sc-message-list {
    background-size: 100%;
    padding: 10px;
    position: relative;
    margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/MessageList.vue